import React, { createContext, useContext, useState } from 'react';

const ErrorDialogContext = createContext();

export const useErrorDialog = () => {
  const context = useContext(ErrorDialogContext);
  if (!context) {
    throw new Error('useErrorDialog must be used within ErrorDialogProvider');
  }
  return context;
};

export const ErrorDialogProvider = ({ children }) => {
  const [errorState, setErrorState] = useState({
    title: '',
    message: '',
    isOpen: false,
  });

  const showError = (title, message) => {
    setErrorState({ title, message, isOpen: true });
  };

  const hideError = () => {
    setErrorState(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <ErrorDialogContext.Provider value={{ showError, hideError, errorState }}>
      {children}
    </ErrorDialogContext.Provider>
  );
};